/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { SUPPORTED_LNGS } from '@/utils/constant/language'

const DETECTION_OPTIONS = {
  order: ['localStorage'],
  caches: ['localStorage'],
}

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    detection: DETECTION_OPTIONS,
    defaultNS: 'common',
    supportedLngs: SUPPORTED_LNGS,
    fallbackLng: 'en-US',
    fallbackNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?v=1.1.3',
    },
  })

export default i18n
